import React from "react";
import { Translate } from "components/common/Translate/Translate";
import { FAQScaffold, IFaq } from "components/features/CompressorCommon/FAQScaffold";

const faqAsList: IFaq[] = [
    {
        question: "faq-1-question",
        answer: "faq-1-ans",
    },
    {
        question: "faq-2-question",
        answer: "faq-2-ans",
    },
    {
        question: "faq-3-question",
        answer: "faq-3-ans",
    },
    {
        question: "faq-4-question",
        answer: "faq-4-ans",
    },
    {
        question: "faq-5-question",
        answer: "faq-5-ans",
    },
    {
        question: "faq-6-question",
        answer: "faq-6-ans",
    },
    {
        question: "faq-7-question",
        answer: "faq-7-ans",
    },
    {
        question: "faq-8-question",
        answer: "faq-8-ans",
    },
    {
        question: "faq-9-question",
        answer: "faq-9-ans",
    },
    {
        question: "faq-10-question",
        answer: "faq-10-ans",
    },
    {
        question: "faq-11-question",
        answer: "faq-11-ans",
    },
    {
        question: "faq-12-question",
        answer: "faq-12-ans",
    },
    {
        question: "faq-13-question",
        answer: "faq-13-ans",
    },
    {
        question: "faq-14-question",
        answer: "faq-14-ans",
    },
    {
        question: "faq-15-question",
        answer: "faq-15-ans",
    },
    {
        question: "faq-16-question",
        answer: "faq-16-ans",
    },
];

const JpgResizerFaq = () => {
    return (
        <FAQScaffold
            faqAsList={faqAsList}
            sectionTitle={<Translate keyName="Frequently-Asked-Questions-title" />}
            sectionSubTitle={<Translate keyName="Frequently-Asked-Questions-sub-title" />}
        />
    );
};

export default JpgResizerFaq;
